import { useAppPersistenceStore } from '@ninjacart/nc-nk-store';
import { Button, Text, View } from 'tamagui';
import { ChevronDown, Plus } from '@tamagui/lucide-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const FollowButton = ({ isFollowing, isFollowLoading, handleButtonClick }) => {
  const { t } = useTranslation();
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);

  if (isFollowLoading) {
    return null;
  }

  return (
    <Button
      size={30}
      width={isFollowing ? 110 : 90}
      backgroundColor={isFollowing ? '$cardbackground' : '$primary'}
      borderColor={isFollowing ? '$primary' : 'transparent'}
      borderWidth={1}
      borderRadius={6}
      justifyContent="center"
      onPress={handleButtonClick}
      testID='kisan_tId_follow_button'
    >
      <View flex={1} flexDirection="row" justifyContent="center" alignItems="center">
        {!isFollowing && <Plus size={16} color={isFollowing ? '$primary' : '#FFF'} />}
        <Text
          fontSize={appLanguage == 'ta' ? 10 : 12}
          fontWeight="400"
           color={isFollowing ? '$primary' : '#FFF'}
        >
          {isFollowing ? t('page.following') : t('page.follow')}
        </Text>
        {isFollowing && <ChevronDown size={16} color="$primary" />}
      </View>
    </Button>
  );
};

export default FollowButton;
